<template>
	<div id="map"></div>
</template>

<script>
import mapboxgl from 'mapbox-gl'
import dealers from '../dealers.json'

export default {
	name: 'ThermoMap',
	geojson: dealers,
	props: ['accessToken'],
	data () {
		return {
			map: null,
			//accessToken: "pk.eyJ1IjoibWhvZmJhdWVyIiwiYSI6ImNpbmlvOW9zYTAwM3R3MmtsdzQzNmlhaHQifQ.U68SeYBseY3_lMpr7fY3Sg",
			//mapStyle: 'mapbox://styles/mhofbauer/cjk2al8er2u6h2rnn8n37svzf'
			mapStyle: 'mapbox://styles/mhofbauer/cjkav11e61xt92rl3c9koh1ny'
			
		}
	},
	created() {
		this.map = null
	},
	mounted() {
		this.createMap()
	},
	methods: {
		contactLink(prop){
			if(prop.url) {
				return `<a href="http://${prop.url}" target="_blank">${prop.url}</a>`
			} else if(prop.email) {
				return `<a href="mailto:${prop.email}">${prop.email}</a>`
			} else {
				return ''
			}
		},
		createMap() {
			mapboxgl.accessToken = this.accessToken
			this.map = new mapboxgl.Map({
				container: this.$el,
				style: this.mapStyle,
				center: [14.041944, 46.61258],
				zoom: 3
			}).on('load', e => {
				this.map.resize()

				let bounds = new mapboxgl.LngLatBounds()


				this.$options.geojson.features.forEach(marker => {

					var el = document.createElement('div');
					el.className = 'marker';
					new mapboxgl.Marker(el)
						.setLngLat(marker.geometry.coordinates)
						.setPopup(new mapboxgl.Popup({ offset: 12 }) // add popups
						.setHTML(`<div class="content"><h3>${marker.properties.company}</h3>
						<p>
							${marker.properties.city}, ${marker.properties.country}<br>
							${marker.properties.phone || ''}<br />
							${this.contactLink(marker.properties)}
							
						</p></div>`))
						.addTo(this.map);




						bounds.extend(marker.geometry.coordinates)
					
				})

				this.$nextTick( () => {
					this.map.fitBounds(bounds)
				})

			})

			

		}
	}
}

</script>
<style src="../assets/mapbox-gl.css"></style>

<style lang="scss">
#map {
	width: 100%;
	height: 100%;
}
.marker {	
   	background: url('../assets/pin_ts.svg') center no-repeat;
	background-size: contain;
	width: 24px;
	height: 24px;	
	cursor: pointer;
	// border-radius: 50%;
	// background: #fff;
	// box-shadow: 0px 0px 2px 2px rgba(255, 255, 255, .75); 
	// background: -moz-radial-gradient(center, ellipse cover, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%); /* FF3.6-15 */
	// background: -webkit-radial-gradient(center, ellipse cover, rgba(255,255,255,1) 0%,rgba(255,255,255,0) 100%); /* Chrome10-25,Safari5.1-6 */
	// background: radial-gradient(ellipse at center, rgba(255,255,255,1) 0%,rgba(255,255,255,0) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
	// filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#00ffffff',GradientType=1 ); /* IE6-9 fallback on horizontal gradient */
}

.mapboxgl-popup {
  max-width: 230px;
}
.mapboxgl-popup-anchor-bottom .mapboxgl-popup-tip {
	border-top-color: #e6e6e6;
}

.mapboxgl-popup-anchor-top .mapboxgl-popup-tip {
	border-bottom-color: #e6e6e6;
}
.mapboxgl-popup-content {
    font-family: 'Open Sans', sans-serif;
	background: #e6e6e6;
	padding: 0;
	.content {
		padding: 0 16px 16px;
	}
	h3 {
		font-family: "MicrogrammaDMedExt", sans-serif;
		font-style: normal;
		font-weight: normal;
		color: #1c75bc;
		text-rendering: optimizeLegibility;
		//margin: 0;
	}
	p {
		font-family: "Montserrat", sans-serif;
		text-rendering: optimizeLegibility;
		margin: 0;
	}
}



</style>
